import { Action, createReducer, on } from '@ngrx/store';
import { ModuleMake } from '../../core/models/modulemake';
import { fetchAhjsData, fetchAhjsFailure, fetchAhjsSuccess, fetchBatteryMakesData, fetchBatteryMakesFailure, fetchBatteryMakesSuccess, fetchBatteryModelsData, fetchBatteryModelsFailure, fetchBatteryModelsSuccess, fetchGovernignCodesData, fetchGovernignCodesFailure, fetchGovernignCodesSuccess, fetchInverterMakesData, fetchInverterMakesFailure, fetchInverterMakesSuccess, fetchInverterModelsData, fetchInverterModelsFailure, fetchInverterModelsSuccess, fetchModuleMakesData, fetchModuleMakesFailure, fetchModuleMakesSuccess, fetchModuleModelsData, fetchModuleModelsFailure, fetchModuleModelsSuccess, fetchOptimizerData, fetchOptimizerFailure, fetchOptimizerSuccess, fetchUtilitiesData, fetchUtilitiesFailure, fetchUtilitiesSuccess } from './dataentry.actions';
import { ModuleModel } from '../../core/models/modulemodel';
import { InverterMake } from '../../core/models/invertermake';
import { InverterModel } from '../../core/models/invertermodel';
import { Ahj } from '../../core/models/ahj';
import { Utility } from '../../core/models/utility';
import { BatteryMake } from '../../core/models/batterymake';
import { BatteryModel } from '../../core/models/batterymodel';
import { OptimizerModel } from '../../core/models/optimizermodel';
import { GoverningCodeModel } from '../../core/models/governingcodes';

export interface DataentryState {
    modulemakes: ModuleMake[];
    modulemodels: ModuleModel[];
    invertermakes: InverterMake[];
    invertermodels: InverterModel[];
    ahjs: Ahj[];
    utilities: Utility[];
    loading: boolean;
    error: any;
    batterymakes: BatteryMake[];
    batterymodels: BatteryModel[];
    optimizers: OptimizerModel[];
    governingcodes: GoverningCodeModel[];
}

export const initialState: DataentryState = {
    modulemakes: [],
    modulemodels: [],
    invertermakes: [],
    invertermodels: [],
    ahjs: [],
    utilities: [],
    loading: false,
    error: null,
    batterymakes: [],
    batterymodels: [],
    optimizers: [],
    governingcodes: []
};

export const DataentryReducer = createReducer(
    initialState,

    // Modulemakes
    on(fetchModuleMakesData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchModuleMakesSuccess, (state, { modulemakes }) => {
        return { ...state, modulemakes, loading: false };
    }),
    on(fetchModuleMakesFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Modulemodels
    on(fetchModuleModelsData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchModuleModelsSuccess, (state, { modulemodels }) => {
        return { ...state, modulemodels, loading: false };
    }),
    on(fetchModuleModelsFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Invertermakes
    on(fetchInverterMakesData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchInverterMakesSuccess, (state, { invertermakes }) => {
        return { ...state, invertermakes, loading: false };
    }),
    on(fetchInverterMakesFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Invertermodels
    on(fetchInverterModelsData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchInverterModelsSuccess, (state, { invertermodels }) => {
        return { ...state, invertermodels, loading: false };
    }),
    on(fetchInverterModelsFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Ahjs
    on(fetchAhjsData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchAhjsSuccess, (state, { ahjs }) => {
        return { ...state, ahjs, loading: false };
    }),
    on(fetchAhjsFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

     // Utilities
     on(fetchUtilitiesData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchUtilitiesSuccess, (state, { utilities }) => {
        return { ...state, utilities, loading: false };
    }),
    on(fetchUtilitiesFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // BATTERY MAKES
    on(fetchBatteryMakesData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchBatteryMakesSuccess, (state, { batterymakes }) => {
        return { ...state, batterymakes, loading: false };
    }),
    on(fetchBatteryMakesFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // BATTERY MODELS
    on(fetchBatteryModelsData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchBatteryModelsSuccess, (state, { batterymodels }) => {
        return { ...state, batterymodels, loading: false };
    }),
    on(fetchBatteryModelsFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // OPTIMIZERS
    on(fetchOptimizerData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchOptimizerSuccess, (state, { optimizers }) => {
        return { ...state, optimizers, loading: false };
    }),
    on(fetchOptimizerFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // GOVERNING CODES
    on(fetchGovernignCodesData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchGovernignCodesSuccess, (state, { governingcodes }) => {
        return { ...state, governingcodes, loading: false };
    }),
    on(fetchGovernignCodesFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),
);

// Selector
export function reducer(state: DataentryState | undefined, action: Action) {
    return DataentryReducer(state, action);
}
